import { render, staticRenderFns } from "./creatCase.vue?vue&type=template&id=8ea993f2&scoped=true&"
import script from "./creatCase.vue?vue&type=script&lang=js&"
export * from "./creatCase.vue?vue&type=script&lang=js&"
import style0 from "./creatCase.vue?vue&type=style&index=0&id=8ea993f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea993f2",
  null
  
)

export default component.exports